import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from "../styles/variants";
import { projects } from '../data/projects';
import WorkCard from './WorkCard';
import WorkPopup from './WorkPopup';

const Work = ({activeComp, setActiveComp, pageHeight = 100, refs}) => {
  const [cardId, setCardId] = useState("");
  const [isToggled, setToggle] = useState(false);

  const observerMargin = Math.floor(pageHeight / 2);
  
  useEffect(() => {
     if (isToggled) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    const observerConfig = {
      rootMargin: `-${
        pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin
      }px 0px -${observerMargin}px 0px`,
    };
    const handleIntersection = function(entries) {
      entries.forEach((entry) => {
        if (entry.target.id !== activeComp && entry.isIntersecting) {
          setActiveComp(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(
      handleIntersection,
      observerConfig
    );
    observer.observe(refs['work'].current);
    return () => observer.disconnect(); // Clenaup the observer if component unmount.
  }, [
    isToggled,
    activeComp,
    setActiveComp,
    observerMargin,
    refs,
    pageHeight
  ]);


  return ( 
    <section id="work" ref={refs['work']} className="section h-[100%]">
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row gap-x-10'>
          <motion.div 
            variants={fadeIn('right', 0.2)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-10 mb-10 lg:mb-0 place-self-end'
          >
          {/*text*/}
            <div className='flex-1'>
              <h2 className='h2 leading-tight text-accent'>
                Projects.
              </h2>
              <p className='max-w-sm mb-16'>
                <span className='text-gradient'>Tap the image to open a card.</span><br/> 
                Here I present my best projects.  I encourage you to check my GitHub portfolio for more of my work. 
              </p>
              <a href="https://github.com/propanibutan?tab=repositories" target="_blank" rel="noreferrer">
                <button className='btn btn-sm'>
                  View all projects
                </button>
              </a>
            </div>
            {projects.slice(0, 2).map((id, i) => {
              return (
              <WorkCard key={i} id={id} onClick={() => {setToggle(true); setCardId(id)}} isToggled={isToggled} setToggle={setToggle}/>
              )
            })}
          </motion.div>
          <motion.div 
            variants={fadeIn('left', 0.2)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-10 place-self-end'
          >
           {projects.slice(2, 5).map((id, i) => {
              return (
              <WorkCard key={i} id={id} onClick={() => {setToggle(true); setCardId(id)}}/>
              )
            })}
          </motion.div>
          <WorkPopup id={cardId} isToggled={isToggled} setToggle={setToggle}/>
        </div>
      </div>
    </section>
  );
};

export default Work;
